import { render, staticRenderFns } from "./Foundations.vue?vue&type=template&id=2702594f&"
import script from "./Foundations.vue?vue&type=script&lang=js&"
export * from "./Foundations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports